var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.user && _vm.user.id)?_c('div',{staticClass:"user-block"},[_c('VUserAvatar',{attrs:{"user":_vm.user}}),_c('div',{staticClass:"user-block__name"},[_vm._t("name",function(){return [_vm._v(_vm._s(_vm.shortFullName))]},{"userName":_vm.user.name})],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }